import { useEffect, useState } from 'react';
import { ajaxRoutes } from '@/globalConstants';
import useAjax from '@/hooks/useAjax.tsx';
import { Property } from '@/api/types.ts';
import { Option } from '@/globalTypes.ts';

function formatPropertiesDataForSelect(data: Property[]): Option[] {
  if (!data) return [];
  return data.map(({ id, name }) => ({ value: id, label: name }));
}

export const usePropertiesQuery = () => {
  const [properties, setProperties] = useState<Option[] | null>(null);
  const [getProperties, loading] = useAjax<{
    data: Property[];
  }>({
    type: 'GET',
    // url: ajaxRoutes.propertiesListV0, // URL to fetch properties
    url: ajaxRoutes.propertiesList, // URL to fetch properties
  });

  useEffect(() => {
    getProperties().then((data) => {
      setProperties(formatPropertiesDataForSelect(data?.properties ?? []));
    });
  }, []);

  return [properties, !properties || loading] as const;
};
